import React from 'react';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import PtrnAccionesAdicionalesBtn from '../PtrnAccionesAdicionalesBtn';
import {existenPtrnAccionesAdicionales} from '../../propsValidationUtils';
import {PtrnAccionesAdicionales, PtrnAccionesInternas} from '../../patronTypes';

const PtrnGridAccionesBase: React.FC<{
   idPrefix: string;
   searchValue?: string;
   onClickClearSearch?: () => void;
   onChangeSearchValue: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
   onKeyDownCapture?: React.KeyboardEventHandler<HTMLDivElement>;
   onClickNuevo?: () => void;
   accionesAdicionales?: PtrnAccionesAdicionales;
   accionesAdicionesSoloIconos?: boolean;
   ptrnRef?: PtrnAccionesInternas;
}> = ({
   idPrefix,
   searchValue,
   onClickClearSearch,
   onChangeSearchValue,
   onKeyDownCapture,
   onClickNuevo,
   //TODO por implementar
   accionesAdicionales,
   accionesAdicionesSoloIconos,
   ptrnRef
}) => {
   //#region busqueda
   const TxtFieldSearchIcon = (
      <InputAdornment position="start">
         <SearchIcon fontSize="small" />
      </InputAdornment>
   );
   const TxtFieldClearButton = searchValue && (
      <InputAdornment position="end">
         <IconButton onClick={onClickClearSearch}>
            <ClearIcon fontSize="small" />
         </IconButton>
      </InputAdornment>
   );
   //#endregion

   //#region ret main
   const existenAccionesAdicionales = existenPtrnAccionesAdicionales(accionesAdicionales);
   return (
      <Grid
         id={`${idPrefix}-grid-acciones-base`}
         container
         alignItems="center"
         spacing={1}
         item
         xs={12}
      >
         <Grid
            id={`${idPrefix}-grid-acciones-base-buscar`}
            container
            item
            xs={4}
            alignContent="flex-start"
            alignItems="flex-start"
         >
            <TextField
               label="Buscar"
               name="search"
               value={searchValue}
               onChange={onChangeSearchValue}
               onKeyDownCapture={onKeyDownCapture}
               variant="outlined"
               size="small"
               fullWidth
               InputProps={{
                  startAdornment: TxtFieldSearchIcon,
                  endAdornment: TxtFieldClearButton
               }}
            />
         </Grid>
         <Grid
            id={`${idPrefix}-grid-acciones-base-otras`}
            container
            item
            xs={8}
            alignContent="flex-end"
            alignItems="center"
            justifyContent={existenAccionesAdicionales ? 'space-between' : 'flex-end'}
            justifyItems="flex-end"
         >
            {existenAccionesAdicionales && (
               <PtrnAccionesAdicionalesBtn
                  acciones={accionesAdicionales}
                  ptrnRef={ptrnRef}
                  soloIconos={accionesAdicionesSoloIconos ?? false}
               />
            )}
            {onClickNuevo && (
               <Button color="primary" variant="outlined" onClick={onClickNuevo}>
                  + Nuevo
               </Button>
            )}
         </Grid>
      </Grid>
   );
   //#endregion
};
export default PtrnGridAccionesBase;
